
<h2 class="mb-3">{{data.attachments_title}}</h2>
<div class="row">
  <div class="col-12">
    <ng-container *ngFor="let att of data.attachments_attachments">
      <div class="card card-teaser rounded shadow mb-15">
        <div class="card-body">
          <h3 class="card-title h5 ">
            <svg class="icon">
              <use href="/bootstrap-italia/dist/svg/sprites.svg#it-clip"></use>
            </svg>
            <a [href]="att.field_media_file?.uri?.url">{{att.field_media_file?.filename}} - ({{att.field_media_file?.filesize | filesize}})</a>
          </h3>
          <div class="card-text font-serif" *ngIf="att.field_descrizione">
            <p>{{att.field_descrizione}}</p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>